import { makeStyles } from '@mui/styles';

const useAboutStyle = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: 'Lato !important',
  },
  aboutContainer: {
    width: '100%',
    marginTop: 80,
    zIndex: 2,
  },
  header: {
    width: '100%',
    fontSize: 'max(3vw, 30px) !important',
    fontWeight: 'bolder !important',
    fontFamily: 'Lato !important',
  },
  biography: {
    marginBottom: '5vh !important',
    fontSize: '1.5rem !important',
  },
  headerSecondary: {
    width: '100%',
    fontSize: 'max(2vw, 24px) !important',
    fontWeight: 'bold !important',
  },
  titleDate: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  list: {
    width: '95%',
    marginBottom: '5vh !important',
    paddingLeft: 20,
  },
  listItem: {
    fontSize: '1.2rem !important',
    marginTop: 20,
    fontFamily: 'Lato !important',
  },
  link: {
    color: 'inherit',
  },
});

export default useAboutStyle;
